import { runWithRenderSlice } from "@otto-ec/global-resources/core";

export const useOverflowCalc = () => {
  let isSpanOverflowingAbortController: AbortController;

  const state = $state({
    /**
 *
 */
    innerSpan: null as HTMLElement | null,
    /**
 *
 */
    value: false,

    /*                                                                */
    /*                                                                                                   */
    /*                                 */
    computeOverflow: () => {
      /*                                                      */
      isSpanOverflowingAbortController?.abort();
      isSpanOverflowingAbortController = new AbortController();

      /*                                */
      runWithRenderSlice(
        () => {
          /*                       */
          if (!state.innerSpan || state.innerSpan.clientWidth < 1) return;
          const { scrollWidth, clientWidth } = state.innerSpan;

          if (scrollWidth > clientWidth) {
            state.value = true;
            return;
          }

          state.value = false;
        },
        { signal: isSpanOverflowingAbortController.signal, silent: true },
      );
    },
  });

  return state;
};
